function percentage(partialValue, totalValue) {
    const value =  ((100 * partialValue) / totalValue).toFixed(2);
    const decimal = Number(value) % 1 !== 0 ? 2 : 0;

    return parseFloat(((100 * partialValue) / totalValue)?.toFixed(decimal)).toLocaleString('pt-br');
}

export { percentage };